import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useNavigate, useLocation, NavigateFunction } from "react-router-dom";
import { useDispatch } from "react-redux";

import Wrapper from "../../StylesWrappers/General/sideBar";
import { sideBarData } from "../../data";
import { AppDispatch, RootState } from "../../store";
import { closeSmallNav } from "../../features/nav/navSlice";
import { changeTextContent } from "../../features/allJobs/editSlice";
import { clearInput } from "../../features/addJob/addJobSlice";
import { SideBarProps } from "../../model";
import { handleLogout } from "../../utils/logoutUser";

const SideBar: React.FC<SideBarProps> = ({
  navSection,
  smScreenClose,
  toggleNavSection,
}) => {
  const { isOpenNav, isOpenSmallNav } = useSelector(
    (store: RootState) => store.navStore
  );

  // const [isLogout, setIsLogout] = useState<boolean>(false);
  const [isHoverIndex, setIsHoverIndex] = useState<number | null>(null);

  const navigate: NavigateFunction = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  // Side bar mouse hover effect
  const handleMouseOver = (index: number) => {
    setIsHoverIndex(index);
  };

  // Navigate to different pages on click of the side bar items
  const handleNavItem = (link: string) => {
    // Logout a user from the side bar
    if (link === "logout") {
      handleLogout(() => {}, navigate);
      return;
    }
    navigate(`/dashboard${link}`); // Dynamically navigate to different page
    dispatch(closeSmallNav()); // Close nav section when each nav item is clicked at small screen
    dispatch(changeTextContent()); // To set button content back to "submit" if job is not updated but user nav to another page
    dispatch(clearInput()); // to set input fields to empty if job is not updated but user nav to another page
  };

  return (
    <Wrapper onClick={() => dispatch(closeSmallNav())}>
      <nav
        className={`${navSection} ${isOpenNav ? toggleNavSection : ""} ${
          isOpenSmallNav ? "add-sm-nav" : "remove-sm-nav"
        }`}
      >
        <ul>
          <FaTimes
            className={smScreenClose}
            onClick={() => dispatch(closeSmallNav())}
          />
          {sideBarData.map((each) => {
            const { id, icon, navName, link } = each;
            return (
              <li
                key={id}
                onClick={() => handleNavItem(link)}
                onMouseOver={() => handleMouseOver(id)}
                onMouseOut={() => setIsHoverIndex(null)}
                className={`${id === isHoverIndex ? "add-hover" : ""}`}
              >
                <p
                  className={`${
                    location.pathname === `/dashboard${link}` ? "add-color" : ""
                  }`}
                >
                  {icon}
                </p>
                <p
                  className={`${
                    location.pathname === `/dashboard${link}` ? "add-color" : ""
                  }`}
                >
                  {navName}
                </p>
              </li>
            );
          })}
        </ul>
      </nav>
    </Wrapper>
  );
};

export default SideBar;
